/* =============================================================================
   HEILMANN HOME · Header-adfærd
   Mega-menu (hover 120 ms + klik + tastatur), mobil-drawer med push-paneler,
   roterende annonceringsbar. Ingen afhængigheder.
   ========================================================================== */
(function () {
  'use strict';

  var reduceret = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- MEGA-MENU --------------------------------------------------- */
  function initMega() {
    var punkter = document.querySelectorAll('.hh-header__nav-punkt--mega');
    if (!punkter.length) return;

    var skygge = document.createElement('div');
    skygge.className = 'hh-mega-skygge';
    document.body.appendChild(skygge);

    var aabenTimer = null, lukTimer = null, aaben = null;

    function luk(punkt) {
      if (!punkt) return;
      var knap = punkt.querySelector('[data-hh-mega-udloeser]');
      var panel = punkt.querySelector('[data-hh-mega]');
      if (knap) knap.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
      if (aaben === punkt) { aaben = null; skygge.classList.remove('is-aaben'); }
    }
    function lukAlle() { punkter.forEach(luk); }
    function aabn(punkt) {
      if (aaben && aaben !== punkt) luk(aaben);
      var knap = punkt.querySelector('[data-hh-mega-udloeser]');
      var panel = punkt.querySelector('[data-hh-mega]');
      if (knap) knap.setAttribute('aria-expanded', 'true');
      if (panel) panel.hidden = false;
      aaben = punkt;
      skygge.classList.add('is-aaben');
    }

    punkter.forEach(function (punkt) {
      var knap = punkt.querySelector('[data-hh-mega-udloeser]');
      if (!knap) return;

      // Hover: 120 ms forsinkelse ved første åbning, øjeblikkeligt skift når en er åben
      punkt.addEventListener('mouseenter', function () {
        clearTimeout(lukTimer);
        if (aaben && aaben !== punkt) { aabn(punkt); return; }
        aabenTimer = setTimeout(function () { aabn(punkt); }, 120);
      });
      punkt.addEventListener('mouseleave', function () {
        clearTimeout(aabenTimer);
        lukTimer = setTimeout(function () { luk(punkt); }, 250);
      });

      // Klik/Enter/Space
      knap.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(aabenTimer);
        if (knap.getAttribute('aria-expanded') === 'true') { luk(punkt); }
        else {
          aabn(punkt);
          var foerste = punkt.querySelector('[data-hh-mega] a');
          if (foerste && e.detail === 0) foerste.focus();   // kun ved tastatur
        }
      });

      // Tab ud af panelet lukker
      punkt.addEventListener('focusout', function (e) {
        if (!punkt.contains(e.relatedTarget)) luk(punkt);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !aaben) return;
      var knap = aaben.querySelector('[data-hh-mega-udloeser]');
      luk(aaben);
      if (knap) knap.focus();
    });
    document.addEventListener('click', function (e) {
      if (aaben && !aaben.contains(e.target)) lukAlle();
    });
    window.addEventListener('scroll', function () {
      if (aaben && window.scrollY > 40) lukAlle();
    }, { passive: true });
    skygge.addEventListener('click', lukAlle);
  }

  /* ---------- MOBIL-MENU -------------------------------------------------- */
  function initMobil() {
    var drawer = document.querySelector('[data-hh-mobilmenu]');
    var overlay = document.querySelector('[data-hh-menu-overlay]');
    var aabnKnap = document.querySelector('[data-hh-menu-aabn]');
    if (!drawer || !aabnKnap) return;

    var paneler = drawer.querySelector('[data-hh-paneler]');
    var rod = drawer.querySelector('[data-hh-panel="rod"]');
    var sidstFokus = null;
    var rodScroll = 0;

    function saetAaben(vaerdi) {
      drawer.hidden = false;
      if (overlay) overlay.hidden = false;
      // næste frame, så transitionen kan køre
      requestAnimationFrame(function () {
        drawer.classList.toggle('is-aaben', vaerdi);
        if (overlay) overlay.classList.toggle('is-aaben', vaerdi);
      });
      aabnKnap.setAttribute('aria-expanded', vaerdi ? 'true' : 'false');
      document.documentElement.style.overflow = vaerdi ? 'hidden' : '';
    }

    function aabn() {
      sidstFokus = document.activeElement;
      saetAaben(true);
      var luk = drawer.querySelector('[data-hh-menu-luk]');
      if (luk) luk.focus();
      if (history.pushState) history.pushState({ hhMenu: 1 }, '');
    }
    function luk() {
      saetAaben(false);
      visRod();
      if (sidstFokus) sidstFokus.focus();
    }

    function visRod() {
      drawer.querySelectorAll('[data-hh-panel]').forEach(function (p) {
        if (p !== rod) { p.hidden = true; p.classList.remove('is-skubbet'); }
      });
      if (rod) { rod.hidden = false; rod.classList.remove('is-skubbet'); }
      if (paneler) paneler.scrollLeft = 0;
      drawer.querySelectorAll('[data-hh-aabn-panel]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      var krop = rod && rod.querySelector('.hh-drawer__body');
      if (krop) krop.scrollTop = rodScroll;
    }

    drawer.querySelectorAll('[data-hh-aabn-panel]').forEach(function (knap) {
      knap.addEventListener('click', function () {
        var id = knap.getAttribute('data-hh-aabn-panel');
        var panel = drawer.querySelector('[data-hh-panel="' + id + '"]');
        if (!panel) return;
        var krop = rod && rod.querySelector('.hh-drawer__body');
        rodScroll = krop ? krop.scrollTop : 0;
        panel.hidden = false;
        if (paneler) paneler.scrollLeft = 0;
        if (rod) rod.classList.add('is-skubbet');
        var fra = knap.closest('[data-hh-panel]');
        if (fra && fra !== rod) fra.classList.add('is-skubbet');
        knap.setAttribute('aria-expanded', 'true');
        var tilbage = panel.querySelector('[data-hh-tilbage]');
        if (tilbage) tilbage.focus();
      });
    });

    /* Tilbage: fra niveau 3 til sit niveau 2-panel, ellers til start. */
    drawer.querySelectorAll('[data-hh-tilbage]').forEach(function (knap) {
      knap.addEventListener('click', function () {
        var til = knap.getAttribute('data-hh-tilbage-til');
        if (!til) { visRod(); return; }
        var her = knap.closest('[data-hh-panel]');
        if (her) her.hidden = true;
        var forrige = drawer.querySelector('[data-hh-panel="' + til + '"]');
        if (forrige) {
          forrige.classList.remove('is-skubbet');
          var aaben = forrige.querySelector('[data-hh-aabn-panel][aria-expanded="true"]');
          if (aaben) { aaben.setAttribute('aria-expanded', 'false'); aaben.focus(); }
        }
      });
    });

    aabnKnap.addEventListener('click', aabn);
    drawer.querySelectorAll('[data-hh-menu-luk]').forEach(function (k) {
      k.addEventListener('click', luk);
    });
    if (overlay) overlay.addEventListener('click', luk);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-aaben')) luk();
    });
    window.addEventListener('popstate', function () {
      if (drawer.classList.contains('is-aaben')) luk();
    });

    // Fokusfælde
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-aaben')) return;
      var synlige = Array.prototype.filter.call(
        drawer.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!synlige.length) return;
      var foerste = synlige[0], sidste = synlige[synlige.length - 1];
      if (e.shiftKey && document.activeElement === foerste) { e.preventDefault(); sidste.focus(); }
      else if (!e.shiftKey && document.activeElement === sidste) { e.preventDefault(); foerste.focus(); }
    });

    // Swipe mod venstre lukker
    var startX = null;
    drawer.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    drawer.addEventListener('touchend', function (e) {
      if (startX === null) return;
      if (startX - e.changedTouches[0].clientX > 60) luk();
      startX = null;
    }, { passive: true });
  }

  /* ---------- ANNONCERINGSBAR --------------------------------------------- */
  function initAnnonce() {
    var bar = document.querySelector('[data-hh-annoncebar]');
    if (!bar) return;
    var slides = bar.querySelectorAll('[data-hh-annonce-slide]');
    if (slides.length < 2) return;

    var i = 0, timer = null;
    var interval = parseInt(bar.getAttribute('data-rotation'), 10) || 5000;

    function vis(n) {
      slides[i].classList.remove('is-aktiv');
      slides[i].setAttribute('aria-hidden', 'true');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-aktiv');
      slides[i].removeAttribute('aria-hidden');
    }
    function start() { if (!reduceret) timer = setInterval(function () { vis(i + 1); }, interval); }
    function stop() { clearInterval(timer); }

    var prev = bar.querySelector('[data-hh-annonce-prev]');
    var next = bar.querySelector('[data-hh-annonce-next]');
    if (prev) prev.addEventListener('click', function () { stop(); vis(i - 1); start(); });
    if (next) next.addEventListener('click', function () { stop(); vis(i + 1); start(); });

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
    start();
  }

  /* Blød skygge under headeren, saa snart siden er scrollet — som i mockuppen. */
  function initSkygge() {
    var hdr = document.querySelector('[data-hh-header]');
    if (!hdr) return;
    var sidst = null;
    var opdater = function () {
      var nu = window.scrollY > 10;
      if (nu !== sidst) { hdr.classList.toggle('er-scrollet', nu); sidst = nu; }
    };
    opdater();
    window.addEventListener('scroll', opdater, { passive: true });
  }

  function init() { initMega(); initMobil(); initAnnonce(); initSkygge(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
